import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './SearchResults.css';
import { searchIndex } from '../../utils/searchIndex';

const categorizedNavItems = {
  Industries: [
    { name: 'Aerospace & Defense', path: '/aerospace-defense' },
    { name: 'Rail Transportation', path: '/rail-transportation' },
    { name: 'Automotive & Mobility', path: '/automotive-mobility' },
    { name: 'Mining', path: '/mining' },
    { name: 'Energy', path: '/energy' },
    { name: 'Utilities & Spatial Intelligence', path: '/utilities' },
    { name: 'Communications', path: '/communications' },
    { name: 'Healthcare & Life Sciences', path: '/healthcare' },
  ],
  Services: [
    { name: 'Services', path: '/services' },
    { name: 'Plant', path: '/plant' },
    { name: 'Network', path: '/network' },
  ],
  Company: [
    { name: 'Investors', path: '/investors' },
    { name: 'Innovation', path: '/innovation' },
    { name: 'Careers', path: '/careers' },
  ],
  Insights: [
    { name: 'Key Resources', path: '/resources' },
    { name: 'CXO Cyience', path: '/cxo' },
    { name: 'Podcasts', path: '/podcasts' },
  ],
  About: [
    { name: 'About Us', path: '/about' },
    { name: 'Leadership', path: '/leadership' },
    { name: 'ValuesFIRST', path: '/values' },
    { name: 'Diversity & inclusion', path: '/diversity' },
    { name: 'Sustainability', path: '/sustainability' },
    { name: 'Partners', path: '/partners' },
    { name: 'Quality', path: '/quality' },
    { name: 'Awards & Accolades', path: '/awards' },
    { name: 'Social responsibility', path: '/social-responsibility' },
    { name: 'In The News', path: '/news' },
    { name: 'Global Offices', path: '/offices' },
  ],
};


const isFuzzyMatch = (text, query) => {
  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  return lowerText.includes(lowerQuery) || lowerQuery.split('').every(ch => lowerText.includes(ch));
};


const highlightMatch = (text, query) => {
  const regex = new RegExp(`(${query})`, 'ig');
  return text.replace(regex, match => `<mark>${match}</mark>`);
};

const SearchResults = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get('query')?.toLowerCase().trim() || '';

  const navResults = {};
  const contentResults = searchIndex(query);

  Object.entries(categorizedNavItems).forEach(([category, items]) => {
    const matchedItems = items.filter(item => isFuzzyMatch(item.name, query));
    if (matchedItems.length > 0) {
      navResults[category] = matchedItems;
    }
  });

  return (
    <div className="search-results-container">
      <h2>Search Results for "<span className="query">{query}</span>"</h2>

      {Object.keys(navResults).length > 0 && (
        <div className="result-section">
          <h3>Navigation Matches</h3>
          {Object.entries(navResults).map(([category, items]) => (
            <div key={category} className="result-category">
              <h4>{category}</h4>
              <ul className="results-list">
                {items.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.path}
                      className="result-link"
                      dangerouslySetInnerHTML={{ __html: highlightMatch(item.name, query) }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      {contentResults.length > 0 && (
        <div className="result-section">
          <h3>Content Matches</h3>
          {contentResults.map((result, index) => (
            <div key={index} className="result-category">
              <h4>
                <Link 
                  to={`${result.path}?highlight=${encodeURIComponent(query)}`}
                  className="result-link"
                >
                  {result.path.replace('/', '').replace(/-/g, ' ').toUpperCase()}
                </Link>
              </h4>
              <p className="content-preview">
                {result.content.length > 150 
                  ? `${result.content.substring(0, 150)}...` 
                  : result.content
                }
              </p>
            </div>
          ))}
        </div>
      )}

      {Object.keys(navResults).length === 0 && contentResults.length === 0 && (
        <p className="no-results">No results found.</p>
      )}
    </div>
  );
};

export default SearchResults;
